import { render, staticRenderFns } from "./k-field-checkbox.vue?vue&type=template&id=5536eb1e"
import script from "./k-field-checkbox.vue?vue&type=script&lang=js"
export * from "./k-field-checkbox.vue?vue&type=script&lang=js"
import style0 from "./k-field-checkbox.vue?vue&type=style&index=0&id=5536eb1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports